import Box from '@mui/material/Box';

import { formatDate } from '#common/utils';
import getDateRecencyColor from '#utils/date-recency';

interface RecencyDateTextProps {
  date?: string | number | Date | undefined;
  fallback?: string | undefined;
}

// Formatted date whose text color reflects recency (see getDateRecencyColor).
// Used on management-side lists so admins/staff can spot recent activity.
export default function RecencyDateText(props: RecencyDateTextProps) {
  const { date, fallback } = props;
  const text = formatDate(date as string | number | Date, fallback);
  const color = getDateRecencyColor(date);

  if (!color) {
    return <>{text}</>;
  }

  return (
    <Box component="span" sx={{ color }}>
      {text}
    </Box>
  );
}
